import React from 'react'
import Text from '../elements/Typo/Text'

export const cellRenderer = (params: any) => {
    console.log('Cell renderer params:', params)
    const value = params?.value ?? params?.data?.[params?.colDef?.field] ?? '-'
    const displayValue = typeof value === 'boolean' ? String(value) : value
    return (
        <div className="flex items-center justify-center pt-1 w-full pr-1">
            <Text size="14" className="truncate whitespace-nowrap" title={displayValue}>
                {displayValue}
            </Text>
        </div>
    )
}
